let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5kdxD")).then(() => parcelRequire('XNSav'));